<template>
  <!-- TicketWidget -->

  <!-- 已删除 不展示 -->
  <div v-if="!!value.deletedAt"/>

  <!-- 按钮 新建/搜索 右侧 -->
  <TicketWidgetLinkButton v-else-if="'LinkButton' == value.type" :widget = "value"/>

  <!-- 链接 列表页右上角 -->
  <a v-else-if = "'Link' == value.type" :href="value.parameter">{{value.label || value.id}}</a>

  <!-- 详情页左右侧 文本内容 -->
  <TicketWidgetLiteral v-else-if="'TicketDetailLiteral' == value.type" :widget = "value"/>

  <!-- 隐藏工单新建页描述框 特殊的 用js 显示/隐藏 -->
  <TicketWidgetNewCenterContent v-else-if="'TicketNewCenterContent' == value.type"/>

  <!-- 特殊的 用js 显示/隐藏 -->
  <TicketDetailReplyForm v-else-if="'TicketDetailReplyForm' == value.type"/>

  <!-- 特殊的 用js 显示/隐藏 -->
  <TicketWidgetMyTicketList v-else-if="'MyTicketList' == value.type" :widget = "value"/>

  <!-- 特殊的 用js 显示/隐藏 -->
  <TicketWidgetJS v-else-if="'JS' == value.type" :widget = "value"/>

  <!-- 特殊的 用js 显示/隐藏 -->
  <TicketWidgetCSS v-else-if="'CSS' == value.type" :widget = "value"/>

  <!-- 特殊的 用js 显示/隐藏 -->
  <TicketWidgetRightField v-else-if="'RightMerchantOrder' == value.type
    || 'RightMerchant' == value.type
    || 'RightShop' == value.type
    || 'RightCustomerSchedule' == value.type
    || 'RightCallInfo' == value.type
    || 'RightWorkflow' == value.type
    || 'RightEndAt' == value.type" :widget = "value"/>

  <!-- 特殊的 用js 显示/隐藏 -->
  <TicketWidgetTopLeftTab v-else-if="'TopLeftTabPane' == value.type" :widget = "value"/>

  <!-- 工单关键字 -->
  <TicketWidgetSegment v-else-if="'TicketDetailSegment' == value.type" :widget = "value"/>

  <!-- 关联工单 -->
  <TicketWidgetRelated v-else-if="'TicketWidgetRelated' == value.type" :widget = "value"/>

  <!-- 特殊的 用js 显示/隐藏 -->
  <TicketWidgetNewButton v-else-if="'TicketNewButton' == value.type || 'TicketNewBtn' == value.type" :widget = "value"/>

  <!-- 特殊的 用js 显示/隐藏 -->
  <AssignToWorkflowButton v-else-if="'AssignToWorkflowButton' == value.type" :widget = "value"/>

  <!-- 其他 -->
  <span v-else>TicketWidget else {{value}}</span>
</template>

<style>
</style>

<script>
export default {
    name : 'TicketWidget',

    props : ['value'],

    created() {
      // console.log('#66 TicketWidget created', this.value, this);
    },

    mounted() {
      // console.log('#70 TicketWidget mounted', this.value, this);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidget.vue